import { render, staticRenderFns } from "./about-slider-text-item.vue?vue&type=template&id=4ffd9265&scoped=true&"
import script from "./about-slider-text-item.vue?vue&type=script&lang=js&"
export * from "./about-slider-text-item.vue?vue&type=script&lang=js&"
import style0 from "./about-slider-text-item.vue?vue&type=style&index=0&id=4ffd9265&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd9265",
  null
  
)

export default component.exports